import { render, staticRenderFns } from "./PleitoCronogramasDesembolsoParceiro.vue?vue&type=template&id=d462c1be"
import script from "./PleitoCronogramasDesembolsoParceiro.vue?vue&type=script&lang=js"
export * from "./PleitoCronogramasDesembolsoParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports